import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Header } from "../components/public/Header";
import { Footer } from "../components/public/Footer";
import { ProductCard } from "../components/public/ProductCard";
import { ProductModal } from "../components/public/ProductModal";

export default function Collections() {
  const [settings, setSettings] = useState(null);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("All");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const params = active === "All" ? {} : { category: active };
    api.get("/products", { params }).then((r) => setProducts(r.data)).catch(() => {});
  }, [active]);

  const filters = ["All", ...categories];

  return (
    <div className="bg-obsidian min-h-screen">
      <Header settings={settings} />

      <section className="pt-36 sm:pt-44 pb-12 max-w-7xl mx-auto px-5 sm:px-8">
        <p className="font-accent text-xs tracking-[0.3em] uppercase text-champagne fade-up">The Wardrobe</p>
        <h1 className="font-heading text-5xl sm:text-7xl text-ink mt-4 fade-up" style={{ animationDelay: "100ms" }}>
          Collections
        </h1>
        <p className="text-ash max-w-xl mt-6 leading-relaxed fade-up" style={{ animationDelay: "200ms" }}>
          Browse the full edit. Tap any piece to view details and enquire via WhatsApp.
        </p>

        <div className="flex flex-wrap gap-3 mt-12">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActive(f)}
              data-testid={`filter-${f.toLowerCase()}`}
              className={`font-accent text-xs tracking-[0.2em] uppercase px-6 py-3 border transition-all duration-300 ${
                active === f
                  ? "bg-champagne text-obsidian border-champagne"
                  : "border-white/15 text-ash hover:border-champagne hover:text-champagne"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-28">
        {products.length === 0 ? (
          <p className="text-ash py-20 text-center">No pieces in this category yet.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} onClick={setSelected} index={i} />
            ))}
          </div>
        )}
      </section>

      <Footer settings={settings} />
      <ProductModal product={selected} settings={settings} onClose={() => setSelected(null)} />
    </div>
  );
}
